import { Component } from '@angular/core';
import { NtapGlobalConstants, Util, ViewState } from '@ntap/core';
import { map, Observable } from 'rxjs';
import { AppUser, AuthService } from '../login.component';

const VIEW_user_profile = 'user_profile';
const TYPE_earhiv_user = 'earhiv_user';
const FQAN_userId = Util.getFullAttrName(
  TYPE_earhiv_user,
  NtapGlobalConstants.ATTR_id
);

@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.html'
})
export class UserProfileComponent {
  readonly VIEW_user = VIEW_user_profile;

  viewState$: Observable<ViewState>;

  constructor(authService: AuthService) {
    this.viewState$ = authService.validUser$.pipe(
      map((user) => this.toViewState(user))
    );
  }

  private toViewState(user: AppUser) {
    return {
      [FQAN_userId]: user.userId.value,
      $itemType: TYPE_earhiv_user
    };
  }
}
